import * as Actions from './catalogoFilterValuesAction'
import { CatalogoFilters } from '../../type/filter'

export const key = 'catalogoFilter'

interface CatalogoFilterState {
  loading: boolean
  error: string | null
  filters: CatalogoFilters | null
}

export interface GlobalCatalogFilterState {
  [key: string]: CatalogoFilterState
}

export const initialFilterState: CatalogoFilterState = {
  loading: false,
  error: null,
  filters: null,
}

export const initialGlobalCatalogoFilterState: GlobalCatalogFilterState = {}

export type CatalogoFilterStateType = typeof initialGlobalCatalogoFilterState

export type GlobalCatalogoFilterStateType =
  typeof initialGlobalCatalogoFilterState

export const catalogoFiltersReducer = (
  state: GlobalCatalogFilterState = initialGlobalCatalogoFilterState,
  action: any
): GlobalCatalogFilterState => {
  const { meta } = action
  const catalogKey = meta?.catalogKey || key

  if (!catalogKey) return state

  switch (action.type) {
    case Actions.CATALOGO_FILTER_VALUES:
      return {
        ...state,
        [catalogKey]: { loading: true, error: null, filters: null },
      }

    case Actions.CATALOGO_FILTER_VALUES_OK:
      return {
        ...state,
        [catalogKey]: {
          loading: false,
          error: null,
          filters: action.payload.data,
        },
      }

    case Actions.CATALOGO_FILTER_VALUES_FAILED:
      return {
        ...state,
        [catalogKey]: { loading: false, error: action.payload, filters: null },
      }

    default:
      return state
  }
}
